import { render, staticRenderFns } from "./VirtualClassroom.vue?vue&type=template&id=d908c8d8&lang=pug"
import script from "./VirtualClassroom.vue?vue&type=script&lang=ts"
export * from "./VirtualClassroom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports